const DEEPSEEK_API_URL = 'https://api.deepseek.com/v1';

export class DeepSeekService {
  constructor(apiKey) {
    this.apiKey = apiKey;
  }

  async generateCompletion(prompt, options = {}) {
    try {
      const response = await fetch(`${DEEPSEEK_API_URL}/chat/completions`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.apiKey}`
        },
        body: JSON.stringify({
          model: 'deepseek-chat',
          messages: [{ role: 'user', content: prompt }],
          temperature: 0.7,
          max_tokens: 1000,
          ...options
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        console.error('DeepSeek API error details:', errorData);
        throw new Error(`DeepSeek API error: ${response.status} ${response.statusText}`);
      }

      const data = await response.json();
      return data.choices[0].message.content;
    } catch (error) {
      console.error('Error calling DeepSeek API:', error);
      throw error;
    }
  }

  async summarize(text) {
    const prompt = `Please provide a concise summary of the following text. Just give me the summary, no explanations or suggestions:\n\n${text}`;
    return this.generateCompletion(prompt);
  }

  async fixGrammar(text) {
    const prompt = `Please fix any grammar mistakes in the following text. Only fix grammar errors, don't make any other changes or suggestions:\n\n${text}`;
    return this.generateCompletion(prompt);
  }

  async extractKeywords(text) {
    const prompt = `Extract and list the main keywords from the following text. Just provide the list, no explanations:\n\n${text}`;
    return this.generateCompletion(prompt);
  }

  async extractEntities(text) {
    const prompt = `Extract and list the semantic entities (like people, organizations, locations, etc.) from the following text. Just provide the list, no explanations:\n\n${text}`;
    return this.generateCompletion(prompt);
  }

  async translate(text, targetLanguage) {
    const prompt = `Translate the following text to ${targetLanguage}. Only provide the translation, no explanations:\n\n${text}`;
    return this.generateCompletion(prompt);
  }

  async shorten(text, limit, limitType = 'char') {
    const prompt = `Shorten the following text to fit within ${limit} ${limitType === 'char' ? 'characters' : 'words'} while preserving the main message. Only provide the shortened text, no explanations:\n\n${text}`;
    return this.generateCompletion(prompt);
  }
} 